import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { ENVIRONMENT } from '@joyinvoice/web/shared/util';

@Injectable({ providedIn: 'root' })
export class BaseApiService {
  protected readonly http = inject(HttpClient);
  protected readonly baseUrl = inject(ENVIRONMENT).apiUrl;

  protected buildParams(query: Record<string, any>): HttpParams {
    let params = new HttpParams();
    Object.entries(query).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        params = params.set(key, String(value));
      }
    });
    return params;
  }

  protected async get<T>(url: string, query?: Record<string, any>): Promise<T> {
    const params = query ? this.buildParams(query) : undefined;
    const response = await firstValueFrom(
      this.http.get<{ success: boolean; data: T }>(url, { params })
    );
    return response.data;
  }

  protected async post<T>(url: string, body?: any): Promise<T> {
    const response = await firstValueFrom(
      this.http.post<{ success: boolean; data: T }>(url, body)
    );
    return response.data;
  }

  protected async patch<T>(url: string, body?: any): Promise<T> {
    const response = await firstValueFrom(
      this.http.patch<{ success: boolean; data: T }>(url, body)
    );
    return response.data;
  }

  protected async delete(url: string): Promise<void> {
    await firstValueFrom(this.http.delete(url));
  }

  protected async put<T>(url: string, body?: any): Promise<T> {
    const response = await firstValueFrom(
      this.http.put<{ success: boolean; data: T }>(url, body)
    );
    return response.data;
  }

  protected async getBlob(url: string): Promise<Blob> {
    return firstValueFrom(
      this.http.get(url, { responseType: 'blob' })
    );
  }
}
